<div class="container">
    <div class="message">
        <h1>Error Message</h1>
        <h3>You are not authorized to access this application</h3>
        <!-- <h5>We apologize for the inconvenience.Please try again later or go to our Main page.</h5> -->
        
    </div>
</div>